import React, { type FC } from 'react';

import { PageTreeMacroHandler } from '@confluence/pagetree-macro/entry-points/PageTreeMacroRenderer.ts';
import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/commonExtensionTypes.ts';
import type { RendererExtensionHandlers } from '@confluence/fabric-extension-lib/entry-points/extensionTypes.ts';

import { NestedAdfSSRRendererWrapperProvider } from './NestedAdfSSRRendererWrapperProvider.tsx';

type PageTreeSSRExtensionHandlerProps = ExtensionHandlerProps & {
	appearance?: string;
	Renderer: FC<any>;
	getExtensionHandlers: (options: any) => RendererExtensionHandlers;
};

export const PageTreeSSRExtensionHandler: FC<PageTreeSSRExtensionHandlerProps> = ({
	contentId,
	extensionKey,
	mode,
	node,
	spaceKey,
	spaceId,
	appearance,
	showTemplateVariablesInPreview,
	showTemplateInputInPreview,
	Renderer,
	getExtensionHandlers,
}) => (
	<NestedAdfSSRRendererWrapperProvider
		appearance={appearance}
		Renderer={Renderer}
		getExtensionHandlers={getExtensionHandlers}
		showTemplateInputInPreview={showTemplateInputInPreview}
		showTemplateVariablesInPreview={showTemplateVariablesInPreview}
	>
		{(RendererWrapper) => (
			<PageTreeMacroHandler
				macroDefaultProps={{
					contentId,
					extensionKey,
					mode,
					node,
					spaceKey,
					spaceId,
				}}
				macroParams={node?.parameters?.macroParams}
				RendererWrapper={RendererWrapper}
			/>
		)}
	</NestedAdfSSRRendererWrapperProvider>
);
